import { locales } from '@americanexpress/conditional-features';

const { EN_US } = locales;
export const hasHotelCreditPage = [EN_US];
